module.exports = __webpack_public_path__ + "static/media/weld_inspect_3.e916c554.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_inspect_3.jpg
// module id = 1872
// module chunks = 0